import type { IApiRequestProps } from '@core/utils/api';
import type { TQueryKey } from '@react/utils/queryHooks';
import type { IPagyPostVMProps, IPostVMProps } from '@data/view-models';

import { api } from './api';

export const QK_FETCH_POST: TQueryKey = 'qk_fetchPost';
export const QK_FETCH_POSTS: TQueryKey = 'qk_fetchPosts';

interface IGetPostsParams extends IApiRequestProps {
  cursor?: string;
  perPage?: number;
  topics?: string[];
}

interface IGetSlugListReturnProps {
  slug: string;
  updatedAt: string;
}

function getPosts({
  cursor,
  topics,
  perPage,
}: IGetPostsParams = {}): Promise<IPagyPostVMProps> {
  return api.get<IPagyPostVMProps>({
    passMetadata: true,
    endpoint: {
      url: '/posts',
      query: {
        cursor,
        topics,
        perPage,
      },
    },
  });
}

interface IGetPostParams extends IApiRequestProps {
  slug: string;
}

function getPost({ slug, signal }: IGetPostParams): Promise<IPostVMProps> {
  return api.get<IPostVMProps>({
    signal,
    endpoint: `/posts/${slug}`,
  });
}

function getSlugList(): Promise<IGetSlugListReturnProps[]> {
  return api.get<IGetSlugListReturnProps[]>({
    endpoint: '/posts/slug-list',
  });
}

export const postApi = {
  getPost,
  getPosts,
  getSlugList,
};
